import React, { useState } from "react";
import {
  Box,
  Stack,
  TextField,
  Typography,
  IconButton,
  Autocomplete,
  InputAdornment,
} from "@mui/material";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddCircleIcon from "@mui/icons-material/AddCircle";
//src
import "../../../Style/dialogstyle.scss";
import EmptyImge from "../../../Assets/empty-image.png";
import { SELECT_MATERIAL } from "../../../Schema/Material";
//date picker
import { useLazyQuery, useQuery } from "@apollo/client";
import SelectMaterailUnit from "../../ReqPurchase/SelectMaterailUnit"; 
import RemainProduct from "../../ReqPurchase/RemainProduct";



export default function ListPurchase({
  listData,
  setListData,
  requireField,
  readOnly,
  disabled,
  dialogTitle,
  disabledCreatePurchase,
  editData, 
  warehouseId,
}) {

  // console.log("dialogTitle", dialogTitle)
  const [touched, setTouched] = useState(false);
  const handleTouch = () => setTouched(true);
  const errorMessage = ["require!", "must bigger than 0!"];

  const listReqPurchMaterial = {
    qty: 0,
    image: "",
    unitPrice: 0,
    checkUnitPrice: 200,
    checkQty: 0,
    materialId: { id: "", title: "" },
    listMaterialUnitId: { id: "", title: "" },
    key: Date.now() + Math.random(),
    unitPricePerItem: 0,
  };
  const handleAdd = () => setListData([...listData, listReqPurchMaterial]);

  const handleRemove = (key) =>
    setListData(
      listData.filter((e) => {
        return e.key !== key;
      })
    );

  const handleUpdateValue = (key, value, fieldName) => {
    const newData = listData?.map((e) => {
      // console.log("e===", e)
      if (value === null) {
        if (key === e.key && fieldName === "materialId") {
          e.materialId = { id: "", title: "" };
          e.listMaterialUnitId = { id: "", title: "" };
          e.image = "";
          e.unitPrice = 0;
        }
        if (key === e.key && fieldName === "listMaterialUnitId") {
          e.listMaterialUnitId = { id: "", title: "" };
          e.image = "";
          e.unitPrice = 0;
        }
      } else {
        if (key === e.key && fieldName === "qty") {
          e.qty = parseFloat(value) < 0 ? 0 : parseFloat(value);
        }
        if (key === e.key && fieldName === "desc") e.desc = value;
        if (key === e.key && fieldName === "materialId") {
          e.listMaterialUnitId.id = "";
          e.listMaterialUnitId.title = "";
          e.materialId = value;
        }
        if (key === e.key && fieldName === "listMaterialUnitId") {
          e.listMaterialUnitId = value;
          e.image = value.imageSrc;
          e.unitPrice = parseFloat(value.unitPrice);
          // e.unitPricePerItem = value.unitPrice
        }
        if (key === e.key && fieldName === "unitPrice") {
          e.unitPrice = parseFloat(value);
        }
      }
      return e;
    });

    setListData(newData);
  };

  const [listMaterialOptions, setMeterialOptions] = useState([]);

  const { refetch } = useQuery(SELECT_MATERIAL, {
    variables: {
      isUse: true,
      groupId: null,
      sectionId: null,
    },
    onCompleted: ({ selectMaterial }) => {
      const Data = selectMaterial?.map((e) => {
        return {
          id: e?._id,
          title: e?.materialKhName
        };
      });
      setMeterialOptions(Data);
    },
    onError: (error) => {
      //  setLoading(true)
      console.log(error?.message);
    },
  });

  return (
    <Stack direction="column" spacing={1} sx={{ width: "100%" }}>
      <Stack direction="row" spacing={1} mb={1}>
        <Typography className="field-title-list" sx={{ width: "10%" }}>
          រូបភាព
        </Typography>
        <Typography className="field-title-list" sx={{ width: "20%" }}>
          ឈ្មោះសម្ភារៈ
        </Typography>
        <Typography className="field-title-list" sx={{ width: "20%" }}>
          ឯកតា
        </Typography> 
        <Typography className="field-title-list" sx={{ width: "20%" }}>
          ចំនួនក្នុងស្តុកបច្ចុប្បន្ន
        </Typography> 
        <Typography className="field-title-list" sx={{ width: "21%" }}>
          ចំនួនត្រូវការ/ដាក់ចូល
        </Typography>
        {/* <Typography className="field-title-list" sx={{ width: "10%" }}>
          តម្លៃ
        </Typography> */}
        <Stack width="5%">
          <Box>
            <IconButton onClick={handleAdd} disabled={disabled}>
              <AddCircleIcon sx={{ color: "#2e3192" }} />
            </IconButton>
          </Box>
        </Stack>
      </Stack>

      { listData?.map((e) => {
        // console.log("e", e);
        return (
          <Stack direction="row" spacing={1} key={e?.key}>
            <Stack width="10%">
              <img
                style={{
                  borderRadius: "10px",
                  objectFit: "cover",
                  width: "80%",
                }}
                src={
                  e.image
                    ? e.image
                    : e?.listMaterialUnitId?.imageSrc
                    ? e?.listMaterialUnitId?.imageSrc
                    : EmptyImge
                }
              />
            </Stack>
            <Stack width="20%" direction="column" justifyContent="center">
              <Autocomplete
                readOnly={readOnly}
                value={e.materialId}
                options={listMaterialOptions}
                onChange={(event, val) =>
                  handleUpdateValue(e.key, val, "materialId")
                }
                getOptionLabel={(option) =>
                  option?.title === undefined ? "ជ្រើសរើស" : option?.title
                }
                isOptionEqualToValue={(option, value) =>
                  option?.value === value?.value
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder={"ជ្រើសរើស"}
                    onFocus={handleTouch}
                    error={
                      (touched && e?.materialId?.id === undefined) ||
                      (requireField && e?.materialId?.id === "") ||
                      (requireField && e?.materialId?.id === undefined)
                    }
                    helperText={
                      (touched &&
                        e?.materialId?.id === undefined &&
                        errorMessage[0]) ||
                      (requireField &&
                        e?.materialId?.id === "" &&
                        errorMessage[0]) ||
                      (requireField &&
                        e?.materialId?.id === undefined &&
                        errorMessage[0])
                    }
                  />
                )}
              />
            </Stack>
            
            <Stack width="20%" direction="column" justifyContent="center">
              <SelectMaterailUnit
                disabled={disabledCreatePurchase ? true : false}
                readOnly={readOnly}
                eachList={e}
                handleUpdateValue={handleUpdateValue}
                onFocus={handleTouch}
                requireField={requireField}
              />
            </Stack>
            
            <Stack width="20%" direction="column" justifyContent="center"> 
              <RemainProduct 
                warehouseId={warehouseId}
                listMaterialUnitId={e.listMaterialUnitId.id}
              />
            </Stack>

            <Stack width="20%" direction="column" justifyContent="center">
              <TextField
                className="text-field"
                fullWidth
                size="small"
                type="number"
                disabled={disabled}
                placeholder="បរិមាណ"
                value={e?.qty}
                onChange={(val) =>
                  handleUpdateValue(e.key, val.target.value, "qty")
                }
                error={
                  (touched && e?.qty === 0) ||
                  (requireField && e?.qty === 0) ||
                  (requireField && e?.qty < 0)
                }
                helperText={
                  (requireField && e?.qty === 0 && errorMessage[1]) ||
                  (requireField && e?.qty < 0 && errorMessage[1])
                }
                inputProps={{
                  max:
                    dialogTitle !== "purchase" && dialogTitle !== "recieve"
                      ? null
                      : e?.checkQty,
                  min: 0,
                }}
              />
            </Stack>

            {/* <Stack width="10%" direction="column" justifyContent="center">
              <TextField
                fullWidth
                size="small"
                type="number"
                placeholder="តម្លៃ"
                disabled={disabled}
                value={e.unitPrice}
                onChange={(val) =>
                  handleUpdateValue(e.key, val.target.value, "unitPrice")
                }
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  ),
                  // max: e.unitPrice
                }}
                error={
                  (touched && e?.unitPrice === 0) ||
                  (requireField && e?.unitPrice === 0) ||
                  (requireField && e?.unitPrice < 0)
                }
                helperText={
                  (requireField && e?.unitPrice === 0 && errorMessage[1]) ||
                  (requireField && e?.unitPrice < 0 && errorMessage[1])
                }
                inputProps={{
                  max:
                    dialogTitle !== "purchase" && dialogTitle !== "recieve"
                      ? null
                      : e?.checkUnitPrice,
                  min: 0,
                }}
              />
            </Stack> */}

            <Stack width="5%" direction="column" justifyContent="center">
              <IconButton
                sx={{ width: "40px", height: "40px" }}
                onClick={(event) => handleRemove(e.key)}
                disabled={disabled}
              >
                <RemoveCircleIcon sx={{ color: "red" }} />
              </IconButton>
            </Stack>
          </Stack>
        );
      })}
    </Stack>
  );
}
